<template>
  <div class="modal-out">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">编辑</div>
        <button type="button" class="btn-close" @click="closeSelf">X</button>
      </div>
      <div class="modal-body">
        <el-form :model="editForm" :rules="rules" ref="editForm">
          <div>
            <el-row>

              <el-col :span="12" class="item">
                <el-form-item label="名称" required prop="name">
                  <el-input v-model="editForm.name" placeholder="请输入名称"></el-input>
                </el-form-item>
              </el-col>

<!--              <el-col :span="12" class="item">-->
<!--                <el-form-item label="状态">-->
<!--                  <el-select v-model="editForm.status" placeholder="请选择状态" @change="changeStatus" style="width:100%">-->
<!--                    <el-option-->
<!--                        v-for="item in statusArr"-->
<!--                        :key="item.value"-->
<!--                        :label="item.label"-->
<!--                        :value="item.value">-->
<!--                    </el-option>-->
<!--                  </el-select>-->
<!--                </el-form-item>-->
<!--              </el-col>-->

              <el-col :span="12" class="item">
                <el-form-item label="地址" required prop="address">
                  <el-input v-model="editForm.address" placeholder="请输入地址"></el-input>
                </el-form-item>
              </el-col>


            </el-row>
          </div>
        </el-form>
      </div>
      <div class="modal-footer">
        <el-button @click.native="closeSelf">取消</el-button>
        <el-button :loading="loading" type="primary" @click.native="confirm('editForm')">提交</el-button>
      </div>
    </div>

  </div>
</template>


<script>

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: 'Edit',
  props: [],
  data() {
    return {

      loading: false,

      editForm:{
        timeStr:timeStr,
        sign:'',
        staffCode:getStaffCode(),

        name:'',
        address:'',

        commandCenterCode:'',
      },

      statusArr: [{
        value: 1,
        label: '正常'
      }, {
        value: 2,
        label: '禁用'
      }],

      rules:{

        name:[
          { required: true, message: '请输入名称', trigger: 'blur' },
        ],
        address:[
          { required: true, message: '请输入地址', trigger: 'blur' },
        ],

      },

    }
  },
  methods: {
    init(row){
      this.$refs.editForm.resetFields();

      this.editForm.name=row.name;
      this.editForm.address=row.address;
      this.editForm.commandCenterCode = row.commandCenterCode;

    },
    closeSelf() {
      this.$emit("closeEdit");
    },
    confirm(editForm){
      this.$refs[editForm].validate((valid) => {
        if(valid){
          this.addSubmit();
        }else {
          return false;
        }
      })
    },
    addSubmit(){
      if(this.loading){
        return;
      }else{
        this.loading = true;
      }
      this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
      this.$axios({
        method: 'post',
        url: this.$shopUrl+"CommandCenter/EditByGov",
        data: this.editForm
      }).then(
          (response) => {
            this.loading = false;
            if (response.data.error == 0) {
              this.$emit("closeEdit");
              this.$emit("getList");
            }else if(response.data.error == 1){
              this.$message({type: 'warning', message: response.data.message});
            }
          }
      )
    },

    changeStatus:function (selVal) {
      this.editForm.status = selVal;
    },

  }
}
</script>

